// extracted by mini-css-extract-plugin
export default {"overlay":"overlay---_3gNX","box":"box---HYhhO","label":"label---sOfcT"};